/* eslint-disable jsx-a11y/anchor-is-valid */
import RecentProjectModel from "./RecentProjectModel";
import { recentProjects } from "../mock/RecentProjects";

const RecentProjects = () => {
  return (
    <section className="bg_index bg_img bg-dark">
      <div className="container">
        <div className="row text-white py-5">
          <div className="col-12">
            <h2 className="text-center">Recent Projects</h2>
            <div className="text-center">
              <p
                className="text-white"
                style={{ maxWidth: "50%", margin: "0 auto" }}
              >
                Warraich Traders has completed many major construction projects.
                Below you will find photos from our portfolio to see the type of
                work we have done.
              </p>
            </div>
          </div>
        </div>

        <div className="row my-4 w-100">
          {recentProjects.map((item) => (
            <div className="col-md-3 my-3" key={item.id}>
              <a href="" data-bs-toggle="modal" data-bs-target="#exampleModal">
                <img src={item.imgSrc} alt="projectAlt" />
              </a>
            </div>
          ))}
        </div>

        <RecentProjectModel />
      </div>
    </section>
  );
};

export default RecentProjects;
